/* eslint-disable newline-before-return */
import useSentence from 'hooks/Sentence';
import { AppContext } from 'App';
import { FC, useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Dimmer, Table, Loader } from 'semantic-ui-react';
import { Loading } from 'components/common';
import { useHistory } from 'react-router-dom';

const Component: FC = () => {
  const [onlyChecked, setChecked] = useState(false);
  const { dispatch } = useContext(AppContext);
  const { sentenceList, update, fetch, deleteOne, isLoading } = useSentence({
    needToFetch: true,
  });
  const history = useHistory();
  const onClick = async (id: string) => {
    await deleteOne(id);
    await fetch();
  };
  const onCheck = (id: string, checked: number) => {
    update(id, checked === 1 ? 0 : 1);
  };

  useEffect(() => {
    dispatch({
      type: 'SET_SENTENCE_IDS',
      payload: {
        sentenceIds: sentenceList.map((v) => v.id),
        checkedSencenteIds: sentenceList
          .filter((v) => v.checked === 1)
          .map((v) => v.id),
      },
    });
  }, [sentenceList]);

  return (
    <>
      {isLoading && (
        <Dimmer active inverted>
          <Loader>Loading...</Loader>
        </Dimmer>
      )}
      <div
        style={{
          width: '100%',
          height: window.outerHeight,
          overflow: 'scroll',
        }}
      >
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>No.</Table.HeaderCell>
              <Table.HeaderCell>日本語</Table.HeaderCell>
              <Table.HeaderCell>
                チェック
                <Checkbox
                  checked={onlyChecked}
                  onClick={() => {
                    setChecked(!onlyChecked);
                  }}
                />
              </Table.HeaderCell>
              <Table.HeaderCell>削除</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {onlyChecked &&
              sentenceList
                .filter((v) => v.checked === 1)
                .map((v, k) => {
                  return (
                    <Table.Row key={v.id}>
                      <Table.Cell>
                        {k+1}
                      </Table.Cell>
                      <Table.Cell>
                        <div
                          onDoubleClick={() =>
                            history.push(`/checktest/${v.id}`)
                          }
                        >
                          {v.jp.length > 50 ? v.jp.slice(0, 50) + '...' : v.jp}
                        </div>
                      </Table.Cell>
                      <Table.Cell>
                        <Checkbox
                          checked={v.checked === 1}
                          onClick={() => onCheck(v.id, v.checked)}
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Button onClick={() => onClick(v.id)} color="red">
                          Delete
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  );
                })}

            {!onlyChecked &&
              sentenceList.map((v,k) => {
                return (
                  <Table.Row key={v.id}>
                      <Table.Cell>
                        {k+1}
                      </Table.Cell>
                    <Table.Cell>
                      <div
                        onDoubleClick={() => history.push(`/checktest/${v.id}`)}
                      >
                        {v.jp.length > 50 ? v.jp.slice(0, 50) + '...' : v.jp}
                      </div>
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox
                        checked={v.checked === 1}
                        onClick={() => onCheck(v.id, v.checked)}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <Button onClick={() => onClick(v.id)} color="red">
                        Delete
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <Loading active={false} />
      {/* <AppError {...error} /> */}
    </>
  );
};

export default Component;
